import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Text } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';

interface SaveAsDraftJudgingModalProps {
  onNoButtonClicked(): void;
  onYesButtonClicked(): void;
}

const SaveAsDraftJudgingModalImpl: React.FC<SaveAsDraftJudgingModalProps> = (props) => {
  const {
    onNoButtonClicked,
    onYesButtonClicked,
  } = props;
  
  const commonStyles = useCommonStyles();

  return (
    <Dialog
      open={true}
      onOpenChange={(_, data) => {
        if (!data.open) onNoButtonClicked();
      }}
    >
      <DialogSurface className={commonStyles.modalSurface}>
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle
            action={<Button
              appearance='transparent'
              title='Close'
              icon={<DismissRegular />}
              onClick={onNoButtonClicked}
            />}
          >
            Save as draft
          </DialogTitle>
          <DialogContent>
            <Text as='p'>
              Please note that the application cannot continue being judged until you click submit. Are you sure you want to save as a draft?
            </Text>
          </DialogContent>
          <DialogActions>
            <Button
              appearance='secondary'
              onClick={() => onNoButtonClicked()}
            >
              No
            </Button>
            <Button
              appearance='primary'
              onClick={() => onYesButtonClicked()}
            >
              Yes, Save as Draft
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export const SaveAsDraftJudgingModal = observer(SaveAsDraftJudgingModalImpl);
